module.exports = __webpack_public_path__ + "img/amenagementExt.1eebfd08.jpg";